// extracted by mini-css-extract-plugin
export var acitonButtons = "_m1-0";
export var additionalIcon = "_m1-f";
export var block = "_m1-1";
export var blockContent = "_m1-7";
export var blockDescription = "_m1-8";
export var blockIcon = "_m1-9";
export var blockTitle = "_m1-6";
export var border = "_m1-a";
export var center = "_m1-l";
export var edge = "_m1-b";
export var edgeLabel = "_m1-c";
export var edgePath = "_m1-d";
export var error = "_m1-e";
export var flowchart = "_m1-g";
export var flowchartContent = "_m1-h";
export var highlighted = "_m1-3";
export var hover = "_m1-4";
export var icon = "_m1-i";
export var left = "_m1-m";
export var navButton = "_m1-j";
export var navButtons = "_m1-k";
export var right = "_m1-n";
export var selected = "_m1-2";
export var small = "_m1-5";